export default __webpack_public_path__ + "static/media/Imagen_fondocanales.8f0dd020.png";